module.exports = __webpack_public_path__ + "img/imgalexm.e3629b0a.png";